import axios, { AxiosResponse } from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

axios.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      localStorage.removeItem('accessToken');
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('accessToken');
    }
    return Promise.reject(error);
  }
);

export class ApiClient {
  private readonly apiUrl: string;

  constructor(basePath: string) {
    this.apiUrl = `${API_URL}${basePath}`;
  }

  private getHeaders = () => {
    const token = localStorage.getItem('accessToken');
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
  };

  get = async <T = any>(path: string, params?: any): Promise<AxiosResponse<T>> =>
    axios.get(`${this.apiUrl}${path}`, {
      params,
      headers: this.getHeaders(),
    });

  post = async <T = any>(path: string, data: any): Promise<AxiosResponse<T>> =>
    axios.post<T>(`${this.apiUrl}${path}`, data, {
      headers: this.getHeaders(),
    });

  put = async <T = any>(path: string, data: any): Promise<AxiosResponse<T>> =>
    axios.put<T>(`${this.apiUrl}${path}`, data, {
      headers: this.getHeaders(),
    });

  delete = async <T = any>(path: string, data?: any, params?: any): Promise<AxiosResponse<T>> =>
    axios.delete<T>(`${this.apiUrl}${path}`, {
      headers: this.getHeaders(),
      data,
      params,
    });
}

export default ApiClient;
